export * from './pagetitle/pagetitle.component';
export * from './loader/loader.component';